const MS_STORE_PROVIDER_ID_MAP = {
  SI: 5104030,
  PROD: 182978,
  CI: 108,
};

export function getMSStoreIdByEnv() {
  const url = window.location.href;

  if (url.includes('redmond.corp.microsoft.com')) {
    return MS_STORE_PROVIDER_ID_MAP.CI;
  }
  if (url.includes('ads-int.microsoft.com') || url.includes('si.bingads.microsoft.com')) {
    return MS_STORE_PROVIDER_ID_MAP.SI;
  }
  return MS_STORE_PROVIDER_ID_MAP.PROD;
}
